import React, {Component} from 'react';
import { connect } from 'react-redux';
import Cta from '../base/cta';
import $ from 'jquery';

class SimulacionSave extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showMsg: true
        };
        this.setStatus = this.props.setStatus.bind(this);
    }

    render(){
        let _self = this;

      return (
          <div className="simulador_save">
              <button onClick={ () => { $('html, body').animate({ scrollTop: 0 }, 800); } } className="angle-up">
                  <img className="dark" alt="" src="/static/imgs/angle-right.svg" />
              </button>
              <Cta click={() => { _self.props.setStatus("DRAFT"); _self.props.modalRef.show(); }} text="" saveIcon className="save red-border" />
              {this.state.showMsg && <span className="save-timestamp">
                  {_self.props.modifiedDate}
                  <button className="close" onClick={ () => { _self.setState({showMsg: false}); } }>
                      <i className="fas fa-times"></i>
                  </button>
              </span>}
          </div>
      );
    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
}

export default connect(mapStateToProps)(SimulacionSave);



// WEBPACK FOOTER //
// ./src/containers/simulador/simulacionsave.js